import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as HeaderLogo } from "../assets/images/str_logo.svg";
import { ReactComponent as HeaderLogoSmall } from "../assets/images/str_logo_small.svg";
import styled from "@mui/styled-engine-sc";
import useMediaQuery from "@mui/material/useMediaQuery";

const HomeButton: React.FC = () => {
  // Calculated manually. DO NOT adjust this unless needed.
  const matches = useMediaQuery("(max-width: 960px)");
  return <Link to="/">{matches ? <SvgLogoSmall /> : <SvgLogo viewBox="200 -150 1300 1300" />}</Link>;
};

const SvgLogo = styled(HeaderLogo)`
  width: 17em;
  display: block;
`;

const SvgLogoSmall = styled(HeaderLogoSmall)`
  width: 3.1em;
  display: block;

  & path,
  polygon {
    fill: #ffffff;
  }
`;

export default HomeButton;
